import { render, staticRenderFns } from "./notification-types-modal.vue?vue&type=template&id=ef5d97be&"
import script from "./notification-types-modal.ts?vue&type=script&lang=ts&"
export * from "./notification-types-modal.ts?vue&type=script&lang=ts&"
import style0 from "./notification-types-modal.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports